import { useInfiniteQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetpolicies(searchInput) {
  return useInfiniteQuery(
    ['policies-get-data', searchInput],
    async ({ pageParam }) => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.POLICIES_API, {
          search: searchInput,
          id__lt: pageParam,
        })
      );
      return res.data;
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage?.last_page ? undefined : lastPage?.last_id;
      },
    }
  );
}
